module.exports = __webpack_public_path__ + "static/media/18ECA43.200f4fe8.jpg";